/**
 * List filtering.
 *
 * Search used to match `group_id` only. That identifier is generated by a model
 * (`api_eval/utils/name_generator.py`) and looks like `response_quality_a3f1b2c9`, so the
 * one thing a person is likely to remember about an evaluator — what it actually says —
 * was the one thing search couldn't find.
 */

export interface SearchableEvaluator {
  group_id: string;
  criteria: string;
}

/** Case-insensitive substring match against the name or the criteria text. */
export function matchesQuery(
  evaluator: SearchableEvaluator,
  query: string
): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return (
    evaluator.group_id.toLowerCase().includes(needle) ||
    evaluator.criteria.toLowerCase().includes(needle)
  );
}

export function filterEvaluators<T extends SearchableEvaluator>(
  evaluators: T[],
  query: string
): T[] {
  const needle = query.trim();
  if (!needle) return evaluators;
  return evaluators.filter((evaluator) => matchesQuery(evaluator, needle));
}
